module.exports = __webpack_public_path__ + "media/react/marketing/components/interactive_prompt/assets/clock_icon-36d5c7eb18b81abd6a52c1b508c0f69f.svg";